import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { MarqueeBand } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { MenuSection } from "@/components/site/Menu";
import { Visit } from "@/components/site/Visit";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const handleNavigate = useCallback((id) => {
    if (id === "top") {
      if (lenisRef.current) lenisRef.current.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="relative bg-cream min-h-screen">
      <div className="grain-overlay" aria-hidden />
      <Nav onNavigate={handleNavigate} />
      <main>
        <Hero onNavigate={handleNavigate} />
        <MarqueeBand />
        <About />
        <MenuSection />
        <Visit />
      </main>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}
